import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoComboOption, PoDialogService, PoDynamicFormField, PoLookupColumn, PoNotificationService, PoSelectComponent, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { ProcessoCadastro, defaultProcessoCadastro } from 'src/app/administrativo/interface/processo-cadastro';
import { ProcessoPreCadastroFornecedor, ProcessoPreCadastroFornecedorDto, defaultProcessoPreCadastroFornecedor } from 'src/app/administrativo/interface/processo-pre-cadastro-fornecedor';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';
import { MunicipioIBGE } from 'src/app/interface/municpio-ibge';
import { AuthService } from 'src/app/service/auth.service';
import { BaseService } from 'src/app/service/base-service';
import { CEPService } from 'src/app/service/cep-service';
import { FornecedorService } from 'src/app/service/fornecedor-service';
import { MunicipioIBGEService } from 'src/app/service/municipio-ibge-service';
import { UtilService } from 'src/app/service/util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pre-cadastro-fornecedor-crud',
  templateUrl: './pre-cadastro-fornecedor-crud.component.html',
  styleUrls: ['./pre-cadastro-fornecedor-crud.component.css']
})
export class PreCadastroFornecedorCrudComponent implements OnInit {

  patternPadraoTotvs: string = environment.patternPadraoTotvs;
  preFornecedor: ProcessoPreCadastroFornecedor = defaultProcessoPreCadastroFornecedor();
  processoCadastro: ProcessoCadastro = defaultProcessoCadastro();

  usuarioLogado: string = '';
  usuarioSolicitante: boolean = false;
  usuarioEngenharia: boolean = false;
  usuarioControladoria: boolean = false;
  usuarioDiretoria: boolean = false;

  bloqueiaDadosSolicitante: boolean = true;
  liberaAvancarProcesso: boolean = true;

  tabelaHistorico: Array<any> = [];
  historico: string = '';
  urgente: string = 'N';
  listaEstado: Array<PoSelectOption>;

  listaContaContabil: Array<PoSelectOption>;

  urlApiProtheus: string = environment.urlApiProtheus;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Pré-cadastro Fornecedor'},
    ],
  };

  advancedMunicipioIBGEFilters: Array<PoDynamicFormField>;
  columnsMunicipioIBGEFilters: Array<PoLookupColumn>;
  fieldFormaterMunicipioIBGEFilters: ((value: MunicipioIBGE) => string);

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
    private utilService: UtilService,
    private authService: AuthService,
    private baseService: BaseService,
    public cepService: CEPService,
    public municipioIBGEService: MunicipioIBGEService,
    private processoCadastroService: ProcessoCadastroService,
    private fornecedorService: FornecedorService,

  ) {

    this.advancedMunicipioIBGEFilters = this.municipioIBGEService.getAdvancedFilter();
    this.columnsMunicipioIBGEFilters = this.municipioIBGEService.getColumnsFilter();
    this.fieldFormaterMunicipioIBGEFilters = this.municipioIBGEService.getFieldFormater;

    this.listaEstado = utilService.getListaEstados();

    this.listaContaContabil = [
      {value: '21111', label: '21111 - Fornecedores Nacionais'},
      {value: '21112', label: '21112 - Fornecedores Estrangeiros'},
      {value: '21113', label: '21113 - Fornecedores Pessoa Física'},
    ]
   }

  @ViewChild('poSelectEst', {static: false}) poSelectEst!: PoSelectComponent;
  @ViewChild('formPrincipal', { static: true }) formPrincipal!: NgForm;

  ngOnInit(): void {

    this.usuarioLogado = localStorage.getItem('CUSRID') || '';

    this.activatedRoute.params.subscribe({
      next : (params) => {
        if ('NPROCESSOCODIGO' in params && 'NCODIGO' in params) {
          this.loadDados(params.NPROCESSOCODIGO, params.NCODIGO);
        } else {
          this.bloqueiaDadosSolicitante = false;
        }
      }, error: () => {
        this.bloqueiaDadosSolicitante = false;
      }
    })



  }

  formataCampo():void{
    this.preFornecedor.CA2AGENCIA = this.preFornecedor.CA2AGENCIA.padStart(4,"0")
  }

  loadDados(NPROCESSOCODIGO: number, NCODIGO: number):void{

    this.processoCadastroService.getProcCadastro(NPROCESSOCODIGO).subscribe({
      next: (ret) => {

        this.processoCadastro = ret;

        this.urgente = ret.CURGENTE;

        this.usuarioSolicitante = (this.processoCadastro.CCODIGOUSUARIOPROTHEUS === this.usuarioLogado);

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_ENGENHARIA']).then((temPermissao) => {
          this.usuarioEngenharia = temPermissao;

          this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_CONTROLADORIA']).then((temPermissao) => {
            this.usuarioControladoria = temPermissao;

            this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_DIRETORIA']).then((temPermissao) => {
              this.usuarioDiretoria = temPermissao;

              this.liberaTela();
            });
          });
        });

      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroPreFornecedor(NCODIGO).subscribe({
      next: (ret) => {
        this.municipioIBGEService.estado = ret.CA2EST;
        this.preFornecedor = ret;
      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroHistoricoLista(NPROCESSOCODIGO).subscribe({
      next: (historico) => {
        this.tabelaHistorico = historico.items;
      }
    })
  }

  liberaTela():void{
    if (['2','4','6'].includes(this.processoCadastro.CSTATUS) && this.usuarioSolicitante){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '1' && this.usuarioEngenharia){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '3' && this.usuarioControladoria){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '5' && this.usuarioDiretoria){
      this.bloqueiaDadosSolicitante = false;
    } else {
      this.liberaAvancarProcesso = false;
    }
  }

  gravarDados(decisao: string):void{

    const dados: ProcessoPreCadastroFornecedorDto = {
      CURGENTE: this.urgente,
      FORNECEDOR: this.preFornecedor,
      CHISTORICO: this.historico,
      CDECISAO: decisao,
    };

    this.processoCadastroService.postProcCadastroPreFornecedor(dados).subscribe({
      next: (ret) => {
        this.goLista();
      }
    })

  }

  confirmarTela():void{

    if (this.formPrincipal.valid){
      let texto = '';
      if (this.processoCadastro.NCODIGO <= 0){
        texto = 'Deseja incluir a solicitação de cadastro de Fornecedor?'
      } else {
        texto = 'Deseja aprovar a solicitação de cadastro de Fornecedor?'
      }

      this.poDialogService.confirm({
        title: 'Avançar processo',
        message: texto,
        confirm: () =>{
          this.gravarDados('A');
        }
      })
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }

  }

  cancelarRecusarTela():void{
    if (this.processoCadastro.CSTATUS){
      if (this.historico){
        this.poDialogService.confirm({
          title: 'Recusar processo',
          message: 'Deseja Recusar o cadastro deste Fornecedor?',
          confirm: () =>{
            this.gravarDados('R');
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Informe uma observação para poder recusar o cadastro do fornecedor.',
          duration: 5000
        })
      }
    } else {
      this.poDialogService.confirm({
        title: 'Cancelar Solicitação',
        message: 'Deseja sair da tela e cancelar a solicitação de cadastro de fornecedor?',
        confirm: () =>{
          this.goLista();
        }
      })
    }
  }

  alteraCep(event: Event | string = '') {
    let cep = '';

    if (typeof event === 'string') {
      cep = event as string;

    } else if (event instanceof Event) {
      cep = (event.target as HTMLInputElement).value;

    } else {
      return;
    }

    const cepLimpo = cep.replace(/[^0-9]+/g, "");

    if (this.preFornecedor.CA2TIPO !== 'X' && cepLimpo.length === 8){
      this.cepService.getObjectByValue(cepLimpo).subscribe(
        (res) => {
          if (('cep' in res)) {
            this.preFornecedor.CA2END      = `${res.logradouro.toUpperCase()}, `;
            this.preFornecedor.CA2BAIRRO   = res.bairro.toUpperCase();
            this.preFornecedor.CA2EST      = res.uf;
            this.preFornecedor.CA2COD_MUN  = res.ibge.substring(2, 7);

            this.municipioIBGEService.estado = res.uf;

            this.poSelectEst.disabled = true;
          } else {
            this.dadosCepLimpo();
          }
        },
        (err)=> {
          this.dadosCepLimpo();
        }
      );
    }
  }

  dadosCepLimpo(): void {
    this.preFornecedor.CA2END      = '';
    this.preFornecedor.CA2BAIRRO   = '';
    this.preFornecedor.CA2COD_MUN  = '';
    this.preFornecedor.CA2MUN      = '';
    this.preFornecedor.CA2EST      = ' ';

    this.municipioIBGEService.estado = '';

    this.poSelectEst.disabled = false;
  }

  municipioIBGESelecionado(row: MunicipioIBGE) {
    this.preFornecedor.CA2MUN = row.CCC2MUN;
  }

  validarCIP():void{

    if (this.preFornecedor.CA2CGC.length===11 || this.preFornecedor.CA2CGC.length===14){

      this.baseService.getValidaCGC(this.preFornecedor.CA2CGC).subscribe({
        next: (ret) => {

          if (this.preFornecedor.CA2CGC !== '00000000000000'){
            this.fornecedorService.getFornecedorLista({MODELO: 'B', CA2CGC: this.preFornecedor.CA2CGC, PRECAD: 'S'}).subscribe({
              next: (lista) => {
                if (lista.items.length > 0){
                  this.poDialogService.alert({
                    title: 'Identificação de Fornecedor',
                    message: `O CNPJ/CPF (${this.preFornecedor.CA2CGC}) informado já está cadastrado para o fornecedor ${lista.items[0].CA2COD} ${lista.items[0].CA2NOME}. Deseja trocar o valor informado?`,
                  })
                  this.preFornecedor.CA2CGC = '';
                } else {

                }
              }
            })
          }



          if (this.preFornecedor.CA2CGC.length===14){
            this.baseService.getDadosCNPJ(this.preFornecedor.CA2CGC).subscribe( {
              next: (dados) => {
                this.preFornecedor.CA2NOME = dados.nome;
                this.preFornecedor.CA2NREDUZ = dados.fantasia.substring(0,20);
                this.preFornecedor.CA2CEP = dados.cep.replace(/[^0-9]+/g, "");

                const telefone = dados.telefone.split("/")

                if (telefone.length){
                  const telefone1 = telefone[0].replace(/[^0-9]+/g, "");
                  this.preFornecedor.CA2DDD = telefone1.substring(0,2);
                  this.preFornecedor.CA2TEL = telefone1.substring(2,100);
                }
                this.alteraCep()
              }
            })
          }
        }
      });
      if (this.preFornecedor.CA2CGC === '00000000000000'){
        this.preFornecedor.CA2EST = 'EX';
        this.preFornecedor.CA2TIPO = 'X';
        this.preFornecedor.CA2INSCR = 'ISENTO';
        this.preFornecedor.CA2COD_MUN = '99999';
      }else if (this.preFornecedor.CA2CGC.length===11){
        this.preFornecedor.CA2TIPO = 'F';
        this.preFornecedor.CA2CODPAIS = '01058';
        this.preFornecedor.CA2PAIS = '105';
      }else if (this.preFornecedor.CA2CGC.length===14){
        this.preFornecedor.CA2TIPO = 'J';
        this.preFornecedor.CA2CODPAIS = '01058';
        this.preFornecedor.CA2PAIS = '105';
      }
    } else {
      this.poNotificationService.warning(
        {
          message: 'Campo deve conter 11 ou 14 caracteres.',
          duration: 5000,
        }
      );
    }
  }

  alteraTipo(value: string):void{

    if (this.preFornecedor.CA2TIPO.trim() === value) return;

    if (this.preFornecedor.CA2TIPO === 'X'){
      this.preFornecedor.CA2CODPAIS = '';
      this.preFornecedor.CA2EST = 'EX';
      this.preFornecedor.CA2INSCR = 'ISENTO';
      this.preFornecedor.CA2COD_MUN = '99999';

      this.poSelectEst.disabled = true;
    } else {
      this.preFornecedor.CA2CODPAIS = '01058';
      this.preFornecedor.CA2PAIS = '105';

      this.preFornecedor.CA2EST      = ' ';
      this.preFornecedor.CA2MUN      = '';
      this.preFornecedor.CA2CEP      = '';
      this.poSelectEst.disabled = false;
    }
  }

  bancoSelecionado(): void{
    if (!this.preFornecedor.CA2BANCO){
      this.preFornecedor.CA2AGENCIA = '';
      this.preFornecedor.CA2NUMCON = '';
    }
  }

  goLista(): void {
    this.router.navigateByUrl('administrativo/pre-cadastro/fornecedor/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  public readonly tabelaHistoricoColunas: Array<PoTableColumn> = [
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', label: 'Usuário'   , width: '15%', visible: true},
    {property: 'DDATA'                      , label: 'Data'      , width: '10%', visible: true, type: 'date', format: 'dd/MM/Y'},
    {property: 'CHORA'                      , label: 'Hora'      , width: '10%', visible: true},
    {property: 'CSTATUS' , width: '12%' , label: 'Status' , visible: true, type: 'label' ,
      labels: [
        { value: '1', color: 'color-03', label: 'Engenharia'},
        { value: '2', color: 'color-05', label: 'Engenharia Negado'},
        { value: '3', color: 'color-08', label: 'Controladoria'},
        { value: '4', color: 'color-07', label: 'Controladoria Negado'},
        { value: '5', color: 'color-01', label: 'Diretoria'},
        { value: '6', color: 'color-02', label: 'Diretoria Negado'},
        { value: '7', color: 'color-10', label: 'Finalizado'},
        { value: 'A', color: 'color-12', label: 'Cancelado'},
      ]
    },
    {property: 'COBSERVACAO'                , label: 'Observação', width: '55%', visible: true},
  ]

  public readonly listaBanco: Array<PoComboOption> = [
      {value: "001", label: "Banco do Brasil - 001"},
      {value: "003", label: "Banco da Amazônia - 003"},
      {value: "004", label: "Banco do Nordeste - 004"},
      {value: "021", label: "Banestes - 021"},
      {value: "025", label: "Banco Alfa - 025"},
      {value: "029", label: "Banerj - 029"},
      {value: "031", label: "Banco Beg - 031"},
      {value: "033", label: "Banco Santander - 033"},
      {value: "036", label: "Banco Bem - 036"},
      {value: "037", label: "Banpará - 037"},
      {value: "038", label: "Banestado - 038"},
      {value: "039", label: "BEP - 039"},
      {value: "040", label: "Banco Cargill - 040"},
      {value: "041", label: "Banrisul - 041"},
      {value: "044", label: "BVA - 044"},
      {value: "045", label: "Banco Opportunity - 045"},
      {value: "047", label: "Banese - 047"},
      {value: "062", label: "Hipercard - 062"},
      {value: "063", label: "Ibibank - 063"},
      {value: "065", label: "Lemon Bank - 065"},
      {value: "066", label: "Banco Morgan Stanley Dean Witter - 066"},
      {value: "069", label: "BPN Brasil - 069"},
      {value: "070", label: "Banco de Brasília – BRB - 070"},
      {value: "072", label: "Banco Rural - 072"},
      {value: "073", label: "Banco Popular - 073"},
      {value: "074", label: "Banco J. Safra - 074"},
      {value: "075", label: "Banco CR2 - 075"},
      {value: "076", label: "Banco KDB - 076"},
      {value: "077", label: "Banco Inter - 077"},
      {value: "085", label: "CREDIFOZ - 085"},
      {value: "096", label: "Banco BMF - 096"},
      {value: "104", label: "Caixa Econômica Federal - 104"},
      {value: "107", label: "Banco BBM - 107"},
      {value: "116", label: "Banco Único - 116"},
      {value: "133", label: "Banco Cresol - 133"},
      {value: "136", label: "Banco Unicred - 136"},
      {value: "151", label: "Nossa Caixa - 151"},
      {value: "175", label: "Banco Finasa - 175"},
      {value: "204", label: "American Express Bank - 204"},
      {value: "208", label: "Banco Pactual - 208"},
      {value: "212", label: "Banco Matone - 212"},
      {value: "213", label: "Banco Arbi - 213"},
      {value: "214", label: "Banco Dibens - 214"},
      {value: "217", label: "Banco Joh Deere - 217"},
      {value: "218", label: "Banco Bonsucesso - 218"},
      {value: "222", label: "Banco Calyon Brasil - 222"},
      {value: "224", label: "Banco Fibra - 224"},
      {value: "225", label: "Banco Brascan - 225"},
      {value: "229", label: "Banco Cruzeiro - 229"},
      {value: "230", label: "Unicard - 230"},
      {value: "233", label: "Banco GE Capital - 233"},
      {value: "237", label: "Bradesco - 237"},
      {value: "237", label: "Next - 237"},
      {value: "241", label: "Banco Clássico - 241"},
      {value: "243", label: "Banco Stock Máxima - 243"},
      {value: "246", label: "Banco ABC Brasil - 246"},
      {value: "248", label: "Banco Boavista Interatlântico - 248"},
      {value: "249", label: "Investcred Unibanco - 249"},
      {value: "250", label: "Banco Schahin - 250"},
      {value: "252", label: "Fininvest - 252"},
      {value: "254", label: "Paraná Banco - 254"},
      {value: "263", label: "Banco Cacique - 263"},
      {value: "260", label: "Nubank - 260"},
      {value: "265", label: "Banco Fator - 265"},
      {value: "266", label: "Banco Cédula - 266"},
      {value: "300", label: "Banco de la Nación Argentina - 300"},
      {value: "318", label: "Banco BMG - 318"},
      {value: "320", label: "Banco Industrial e Comercial - 320"},
      {value: "336", label: "C6 Bank - 336"},
      {value: "356", label: "ABN Amro Real - 356"},
      {value: "341", label: "Itau - 341"},
      {value: "347", label: "Sudameris - 347"},
      {value: "366", label: "Banco Societe Generale Brasil - 366"},
      {value: "370", label: "Banco WestLB - 370"},
      {value: "376", label: "JP Morgan - 376"},
      {value: "380", label: "PicPay Serviços S.A - 380"},
      {value: "389", label: "Banco Mercantil do Brasil - 389"},
      {value: "394", label: "Banco Mercantil de Crédito - 394"},
      {value: "399", label: "HSBC - 399"},
      {value: "409", label: "Unibanco - 409"},
      {value: "412", label: "Banco Capital - 412"},
      {value: "422", label: "Banco Safra - 422"},
      {value: "453", label: "Banco Rural - 453"},
      {value: "456", label: "Banco Tokyo Mitsubishi UFJ - 456"},
      {value: "464", label: "Banco Sumitomo Mitsui Brasileiro - 464"},
      {value: "477", label: "Citibank - 477"},
      {value: "487", label: "Deutsche Bank - 487"},
      {value: "488", label: "Banco Morgan Guaranty - 488"},
      {value: "492", label: "Banco NMB Postbank - 492"},
      {value: "494", label: "Banco la República Oriental del Uruguay - 494"},
      {value: "495", label: "Banco La Provincia de Buenos Aires - 495"},
      {value: "505", label: "Banco Credit Suisse - 505"},
      {value: "600", label: "Banco Luso Brasileiro - 600"},
      {value: "604", label: "Banco Industrial - 604"},
      {value: "610", label: "Banco VR - 610"},
      {value: "611", label: "Banco Paulista - 611"},
      {value: "612", label: "Banco Guanabara - 612"},
      {value: "613", label: "Banco Pecunia - 613"},
      {value: "623", label: "Banco Panamericano - 623"},
      {value: "626", label: "Banco Ficsa - 626"},
      {value: "630", label: "Banco Intercap - 630"},
      {value: "633", label: "Banco Rendimento - 633"},
      {value: "634", label: "Banco Triângulo - 634"},
      {value: "637", label: "Banco Sofisa - 637"},
      {value: "638", label: "Banco Prosper - 638"},
      {value: "643", label: "Banco Pine - 643"},
      {value: "653", label: "Banco Indusval - 653"},
      {value: "654", label: "Banco A.J. Renner - 654"},
      {value: "655", label: "Banco Votorantim - 655"},
      {value: "707", label: "Banco Daycoval - 707"},
      {value: "719", label: "Banif - 719"},
      {value: "721", label: "Banco Credibel - 721"},
      {value: "734", label: "Banco Gerdau - 734"},
      {value: "735", label: "Banco Neon - 735"},
      {value: "738", label: "Banco Morada - 738"},
      {value: "739", label: "Banco Galvão de Negócios - 739"},
      {value: "740", label: "Banco Barclays - 740"},
      {value: "741", label: "BRP - 741"},
      {value: "743", label: "Banco Semear - 743"},
      {value: "745", label: "Banco Citibank - 745"},
      {value: "746", label: "Banco Modal - 746"},
      {value: "747", label: "Banco Rabobank International - 747"},
      {value: "748", label: "Banco Cooperativo Sicredi - 748"},
      {value: "749", label: "Banco Simples - 749"},
      {value: "751", label: "Dresdner Bank - 751"},
      {value: "752", label: "BNP Paribas - 752"},
      {value: "753", label: "Banco Comercial Uruguai - 753"},
      {value: "755", label: "Banco Merrill Lynch - 755"},
      {value: "756", label: "Banco Sicoob - 756"},
      {value: "757", label: "KEB - 757"},
      {value: "403", label: "Cora SCD S.A. - 403"}

  ]

}
